import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import { GlobalStyle } from '../../global/global';
import './styles.css';
import { Box, Text, Heading, List, ListItem, ListIcon, Link, Flex } from '@chakra-ui/react';

import TilesSection from '../../sections/TilesSection/TilesSection';
import ContactSection from '../../sections/ContactSection/ContactSection';
import ImageWithBoxSection from '../../sections/ImageWithBoxSection/ImageWithBoxSection';
import StyledButton from '../../components/Button/Button';
import TabsComponentDato from '../../sections/TabsComponentDato/TabsComponentDato';
import { StyledHeading, StyledTitle } from './styles';
import { CheckIcon } from '@chakra-ui/icons';

const image = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=610534&ext=.webp',
    alt: 'Kobieta przyjmująca paczkę',
};

const inpostTabsConfig = {
    selectLabel: 'Forma dostawy:',
    tabs: [
        {
            tabLabel: 'InPost Kurier',
            tabContent: (
                <Box
                    display={{ base: 'grid', lg: 'flex' }}
                    gap={{ base: '30px', lg: 0 }}
                    mx={'-15px'}
                >
                    <Box
                        mx={'15px'}
                        display={'flex'}
                        flexDir={'column'}
                        justifyContent={'center'}
                        flex={{ lg: '0 0 calc(50% -30px)' }}
                        maxWidth={{ lg: 'calc(50% - 30px)' }}
                        padding={'35px'}
                        background={'#1AAC7A'}
                    >
                        <StyledHeading>{'InPost Kurier'}</StyledHeading>
                        <Text fontSize={'15px'} marginBottom={'15px'}>
                            {
                                'Wysyłaj swoje paczki szybko i bezproblemowo z usługą InPost Kurier gwarantującą bezpieczną i terminową dostawę pod wskazany adres.'
                            }
                        </Text>
                        <StyledButton
                            href={
                                'https://pomoc.idosell.com/sprzedaz/kurierzy-i-generowanie-przesylek/inpost'
                            }
                            style={'default'}
                            target="_self"
                        >
                            {'Włącz dostawę InPost Kurier'}
                        </StyledButton>
                    </Box>
                    <Box
                        mx={'15px'}
                        flex={{ lg: '0 0 calc(50% -30px)' }}
                        maxWidth={{ lg: 'calc(50% - 30px)' }}
                    >
                        <List
                            spacing={'15px'}
                            fontSize={'18px'}
                            lineHeight={'27px'}
                            color={'#171717'}
                        >
                            <ListItem display={'flex'} alignItems={'center'}>
                                <ListIcon as={CheckIcon} mr={'30px'} />
                                <Box>
                                    <Text fontSize={'21px'} lineHeight={'1.5'} fontWeight={'600'}>
                                        Wiele sposobów nadania
                                    </Text>
                                    <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                        punkt POP, odbiór kuriera, nadanie w oddziale
                                    </Text>
                                </Box>
                            </ListItem>
                            <ListItem display={'flex'} alignItems={'center'}>
                                <ListIcon as={CheckIcon} mr={'30px'} />
                                <Box>
                                    <Text fontSize={'21px'} lineHeight={'1.5'} fontWeight={'600'}>
                                        Dostarczenie na konkretną godzinę
                                    </Text>
                                    <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                        Możesz skorzystać z usługi Doręczenia 10/12/17. InPost
                                        doręczy Twoje przesyłki w dni robocze do określonej przez
                                        Ciebie godziny.
                                    </Text>
                                </Box>
                            </ListItem>
                            <ListItem display={'flex'} alignItems={'center'}>
                                <ListIcon as={CheckIcon} mr={'30px'} />
                                <Box>
                                    <Text fontSize={'21px'} lineHeight={'1.5'} fontWeight={'600'}>
                                        Obsługa pobraniowa płatności
                                    </Text>
                                    <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                        Kurier InPost oferuje możliwość płatności za zamówienie przy
                                        odbiorze, co zwiększa komfort klientów i zmniejsza liczbę
                                        porzuconych koszyków.
                                    </Text>
                                </Box>
                            </ListItem>
                            <ListItem display={'flex'} alignItems={'center'}>
                                <ListIcon as={CheckIcon} mr={'30px'} />
                                <Box>
                                    <Text fontSize={'21px'} lineHeight={'1.5'} fontWeight={'600'}>
                                        Paczki niestandardowe
                                    </Text>
                                    <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                        Kurier InPost umożliwia wysyłkę paczek o niestandardowych
                                        wymiarach lub kształtach, dzięki elastycznym opcjom
                                        logistycznym.
                                    </Text>
                                </Box>
                            </ListItem>
                        </List>
                    </Box>
                </Box>
            ),
        },
        {
            tabLabel: 'InPost Paczkomaty 24/7',
            tabContent: (
                <Box
                    display={{ base: 'grid', lg: 'flex' }}
                    gap={{ base: '30px', lg: 0 }}
                    mx={'-15px'}
                >
                    <Box
                        mx={'15px'}
                        display={'flex'}
                        flexDir={'column'}
                        justifyContent={'center'}
                        flex={{ lg: '0 0 calc(50% -30px)' }}
                        maxWidth={{ lg: 'calc(50% - 30px)' }}
                        padding={'35px'}
                        background={'#1AAC7A'}
                    >
                        <StyledHeading>{'InPost Paczkomaty 24/7'}</StyledHeading>
                        <Text fontSize={'15px'} marginBottom={'15px'}>
                            {
                                'Korzystaj z InPost Paczkomatów 24/7, żeby odbierać i wysyłać swoje przesyłki o dowolnej porze, w łatwo dostępnych punktach samoobsługowych.'
                            }
                        </Text>
                        <StyledButton
                            href={
                                'https://pomoc.idosell.com/sprzedaz/kurierzy-i-generowanie-przesylek/paczkomaty-inpost'
                            }
                            style={'default'}
                            target="_self"
                        >
                            {'Włącz dostawę InPost Paczkomaty'}
                        </StyledButton>
                    </Box>
                    <Box
                        mx={'15px'}
                        flex={{ lg: '0 0 calc(50% -30px)' }}
                        maxWidth={{ lg: 'calc(50% - 30px)' }}
                    >
                        <List
                            spacing={'15px'}
                            fontSize={'18px'}
                            lineHeight={'27px'}
                            color={'#171717'}
                        >
                            <ListItem display={'flex'} alignItems={'center'}>
                                <ListIcon as={CheckIcon} mr={'30px'} />
                                <Box>
                                    <Text fontSize={'21px'} lineHeight={'1.5'} fontWeight={'600'}>
                                        Wiele sposobów nadania
                                    </Text>
                                    <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                        punkt POP, odbiór kuriera, nadanie w oddziale
                                    </Text>
                                </Box>
                            </ListItem>
                            <ListItem display={'flex'} alignItems={'center'}>
                                <ListIcon as={CheckIcon} mr={'30px'} />
                                <Box>
                                    <Text fontSize={'21px'} lineHeight={'1.5'} fontWeight={'600'}>
                                        Trzy rozmiary skrytek: A, B, C
                                    </Text>
                                    <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                        Paczkomaty obsługują przesyłki o różnych wymiarach - rozmiar
                                        A: 8 x 38 x 64 cm, rozmiar B: 19 x 38 x 64 cm, rozmiar C: 41
                                        x 38 x 64 cm.
                                    </Text>
                                </Box>
                            </ListItem>
                            <ListItem display={'flex'} alignItems={'center'}>
                                <ListIcon as={CheckIcon} mr={'30px'} />
                                <Box>
                                    <Text fontSize={'21px'} lineHeight={'1.5'} fontWeight={'600'}>
                                        Obsługa płatności przy odbiorze
                                    </Text>
                                    <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                        Klienci mogą zapłacić za zamówienie dopiero przy odbiorze
                                        przesyłki, co zwiększa ich poczucie bezpieczeństwa przy
                                        zakupach online.
                                    </Text>
                                </Box>
                            </ListItem>
                            <ListItem display={'flex'} alignItems={'center'}>
                                <ListIcon as={CheckIcon} mr={'30px'} />
                                <Box>
                                    <Text fontSize={'21px'} lineHeight={'1.5'} fontWeight={'600'}>
                                        Paczka w weekend - dostawa także w sobotę!
                                    </Text>
                                    <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                        Twój klient może zdecydować się na dodatkową opcję dostawy,
                                        obejmującą doręczenie przesyłek w sobotę. Ta usługa jest
                                        realizowana tylko jeśli klient nada swoją przesyłkę w piątek
                                        do miast z oddziałami sieci kurierskiej InPost.
                                    </Text>
                                </Box>
                            </ListItem>
                        </List>
                    </Box>
                </Box>
            ),
        },
    ],
};

export default function InpostPage() {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <Box id="inpost_integration">
                <HeroSection
                    type="integration"
                    title="Przesyłki InPost w sklepie IdoSell"
                    subTitle={
                        <Text
                            color={'white'}
                            fontSize={'1.125rem'}
                            textAlign={{ base: 'center', lg: 'left' }}
                        >
                            {
                                'Włącz dostawy InPost w swoim sklepie internetowym ioferuj jedną z najpopularniejszych, najszybszych i najwygodniejszych form wysyłki towarów.'
                            }
                        </Text>
                    }
                    image={image}
                    integrationInfo={{
                        integrationCategory: 'Dostawy z IdoSell..',
                        integrationName: 'InPost',
                        integrationHref:
                            'https://pomoc.idosell.com/sprzedaz/kurierzy-i-generowanie-przesylek/inpost',
                    }}
                />

                <div className="homepage containerIdosellPages">
                    <Box
                        display={'flex'}
                        flexDirection={{ base: 'column', xl: 'row' }}
                        margin={{ base: '0 15px', md: 0 }}
                        paddingTop={{ base: '10px' }}
                        paddingBottom={{ base: '50px', lg: '100px' }}
                    >
                        <TilesSection
                            title={'Dlaczego warto proponować klientom InPost?'}
                            tiles={[
                                {
                                    title: 'Najpopularniejsza forma dostawy',
                                    content:
                                        'Wg Raportu Gemius z 2024 roku, dostawa do automatu paczkowego to najpopularniejsza forma dostawy - korzysta z niej 81% kupujących (z czego aż 88% wybiera Paczkomat® InPost).',
                                },
                                {
                                    title: 'Szeroka sieć Paczkomatów',
                                    content:
                                        'InPost ma ponad 25 tys. punktów odbioru, dostępnych w całej Polsce, w dogodnych lokalizacjach. Dzięki temu klienci mogą odbierać paczki wygodnie, 24/7, blisko domu lub pracy.',
                                },
                                {
                                    title: 'Wysyłaj paczki w Polsce i za granicę',
                                    content:
                                        'Szybka dostawa na terenie Polski oraz do wybranych krajów Europy. Dzięki sprawnej logistyce i szerokiej sieci partnerów zamówienia docierają do klientów terminowo, niezależnie od granic.',
                                },
                                {
                                    title: 'Ekspresowa dostawa i odbiór 24/7',
                                    content:
                                        'Szybkie doręczenia, nawet tego samego dnia, oraz możliwość odbioru paczek o każdej porze. Dzięki temu klienci mogą dostosować dostawę do swojego harmonogramu bez ograniczeń czasowych.',
                                },
                                {
                                    title: 'Aplikacja mobilna i bezdotykowy odbiór paczek',
                                    content:
                                        'Intuicyjna aplikacja umożliwia śledzenie przesyłek i ich odbiór bez konieczności dotykania ekranu Paczkomatu. To wygodne i higieniczne rozwiązanie, które zwiększa komfort użytkowników.',
                                },
                                {
                                    title: 'Ekologiczne podejście i program ekozwrotów',
                                    content:
                                        'Klienci mogą bezpłatnie oddawać nieużywane ubrania, elektronikę czy książki do fundacji poprzez Paczkomaty. To sposób na zmniejszenie odpadów i wsparcie gospodarki obiegu zamkniętego.',
                                },
                            ]}
                        />
                    </Box>
                    <Box paddingBottom={{ base: '50px', lg: '150px' }}>
                        <StyledTitle>
                            {'Poznaj usługi InPost stworzone dla Twojego biznesu'}
                        </StyledTitle>
                        <TabsComponentDato {...inpostTabsConfig} />
                    </Box>
                    <Box paddingBottom={{ base: '35px', lg: '100px' }}>
                        <Heading
                            as="h2"
                            fontWeight={600}
                            fontSize={{ base: '25px', lg: '34px' }}
                            lineHeight={{ base: '37px', lg: '48px' }}
                            textAlign={'center'}
                            marginBottom={{ base: '5px', lg: '20px' }}
                        >
                            {'InPost w Twoim sklepie - włącz szybkie dostawy '}
                        </Heading>
                        <Text
                            fontSize={{ base: '16px', lg: '18px' }}
                            marginBottom={{ base: '35px', lg: '50px' }}
                            textAlign={'center'}
                        >
                            Wybierz sposób integracji i włącz dostawy InPost w swoim sklepie
                            internetowym.
                        </Text>
                        <Flex
                            flexDirection={{ base: 'column', md: 'row' }}
                            gap={{ base: '15px', lg: '30px' }}
                        >
                            <Flex
                                aspectRatio={1}
                                padding={{ base: '35px 20px', xl: '95px 50px' }}
                                background={'#E3E3E3'}
                                flexGrow={1}
                                flexDirection={'column'}
                                flexBasis={{md: .5}}
                            >
                                <Text
                                    as="strong"
                                    fontSize={{ base: '46px', xl: '51px' }}
                                    marginBottom={{ base: '20px', xl: '45px' }}
                                >
                                    .broker
                                </Text>
                                <Text
                                    as="strong"
                                    fontSize={{ base: '24px', lg: '34px' }}
                                    lineHeight={1.4}
                                    marginBottom={{ base: '20px', lg: '15px' }}
                                    fontWeight={600}
                                >
                                    Usługi kurierskie bez formalności
                                </Text>
                                <Text
                                    display={{ lg: 'none' }}
                                    fontSize={'15px'}
                                    marginBottom={'20px'}
                                >
                                    Korzystaj z korzystnych warunków, bez indywidualnej umowy.
                                    Proponuj klientom darmową dostawę Smile.
                                </Text>
                                <Text display={{ base: 'none', lg: 'block' }} marginBottom={'15px'}>
                                    Korzystaj z korzystnych warunków, które nie wymagają
                                    podpisywania indywidualnej umowy z InPostem. Zyskaj dostęp do
                                    pełnej oferty, w tym kuriera i Paczkomatów, a także korzystaj z{" "}
                                    <b>szybkich zwrotów InPost</b>. Dodatkowo, możesz proponować
                                    klientom darmową dostawę Smile.
                                </Text>
                                <Box marginTop={'auto'}>
                                    <StyledButton
                                        href={'https://www.idosell.com/pl/broker/'}
                                        style={'default'}
                                        target="_self"
                                    >
                                        Poznaj IdoSell Broker
                                    </StyledButton>
                                </Box>
                            </Flex>
                            <Flex
                                aspectRatio={1}
                                padding={{ base: '35px 20px', xl: '95px 50px' }}
                                background={'#E3E3E3'}
                                flexGrow={1}
                                flexDirection={'column'}
                                flexBasis={{md: .5}}
                            >
                                <Text
                                    as="strong"
                                    fontSize={{ base: '46px', xl: '51px' }}
                                    marginBottom={{ base: '20px', xl: '45px' }}
                                >
                                    .integracje
                                </Text>
                                <Text
                                    as="strong"
                                    fontSize={{ base: '24px', lg: '34px' }}
                                    lineHeight={1.4}
                                    marginBottom={{ base: '20px', lg: '15px' }}
                                    fontWeight={600}
                                >
                                    Wbudowane integracje z kurierami 
                                </Text>
                                <Text
                                    display={{ lg: 'none' }}
                                    fontSize={'15px'}
                                    marginBottom={'20px'}
                                >
                                    Zintegruj InPost na własnych warunkach, korzystając z indywidualnej umowy z kurierem.
                                </Text>
                                <Text display={{ base: 'none', lg: 'block' }} marginBottom={'15px'}>
                                Zintegruj InPost na własnych warunkach, korzystając z indywidualnej umowy z kurierem. Korzystaj z integracji IdoSell z InPostem i wysyłaj paczki kurierem InPost lub Paczkomatami.
                                </Text>
                                <Box marginTop={'auto'}>
                                    <StyledButton
                                        href={'https://pomoc.idosell.com/sprzedaz/kurierzy-i-generowanie-przesylek/konfiguracja-kurierow-informacja-ogolne'}
                                        style={'default'}
                                        target="_self"
                                    >
                                        Konfiguracja dostawy w sklepie IdoSell
                                    </StyledButton>
                                </Box>
                            </Flex>
                        </Flex>
                    </Box>
                    <Box px={{ base: '15px', lg: 0 }}>
                        <ImageWithBoxSection
                            id="inpostpay_bgc"
                            image={{
                                url: 'https://www.idosell.com/panel/file-gate.php?id=610801&ext=.webp',
                            }}
                            boxSide="right"
                            rightSection={
                                <Box
                                    id="right_box"
                                    display={{ base: 'none', lg: 'flex' }}
                                    flexDirection={'column'}
                                    justifyContent={'center'}
                                >
                                    <Text
                                        fontSize={'26px'}
                                        lineHeight={'34px'}
                                        color={'white'}
                                        textAlign={'center'}
                                        mb={'30px'}
                                        fontWeight={'700'}
                                    >
                                        Włącz InPost Pay i spełnij potrzeby swoich klientów
                                    </Text>
                                    <List
                                        spacing={'15px'}
                                        fontSize={'18px'}
                                        lineHeight={'27px'}
                                        color={'#fff'}
                                    >
                                        <ListItem display={'flex'} alignItems={'center'}>
                                            <ListIcon
                                                as={CheckIcon}
                                                mr={'30px'}
                                                color={'#171717'}
                                            />
                                            <Box>
                                                <Text fontSize={'16px'} lineHeight={'1.5'}>
                                                    Szybka finalizacja zakupów z poziomu aplikacji
                                                    mobilnej InPost Mobile
                                                </Text>
                                            </Box>
                                        </ListItem>
                                        <ListItem display={'flex'} alignItems={'center'}>
                                            <ListIcon
                                                as={CheckIcon}
                                                mr={'30px'}
                                                color={'#171717'}
                                            />
                                            <Box>
                                                <Text fontSize={'16px'} lineHeight={'1.5'}>
                                                    Podgląd zawartości i statusów zamówień
                                                </Text>
                                            </Box>
                                        </ListItem>
                                        <ListItem display={'flex'} alignItems={'center'}>
                                            <ListIcon
                                                as={CheckIcon}
                                                mr={'30px'}
                                                color={'#171717'}
                                            />
                                            <Box>
                                                <Text fontSize={'16px'} lineHeight={'1.5'}>
                                                    Rejestracja do usługi tylko raz wraz z
                                                    zapisaniem danych do płatności i dostawy
                                                </Text>
                                            </Box>
                                        </ListItem>{' '}
                                        <ListItem display={'flex'} alignItems={'center'}>
                                            <ListIcon
                                                as={CheckIcon}
                                                mr={'30px'}
                                                color={'#171717'}
                                            />
                                            <Box>
                                                <Text fontSize={'16px'} lineHeight={'1.5'}>
                                                    Wybór ulubionych form płatności (BLIK, karta
                                                    płatnicza, Apple Pay, Google Pay)
                                                </Text>
                                            </Box>
                                        </ListItem>{' '}
                                        <ListItem display={'flex'} alignItems={'center'}>
                                            <ListIcon
                                                as={CheckIcon}
                                                mr={'30px'}
                                                color={'#171717'}
                                            />
                                            <Box>
                                                <Text fontSize={'16px'} lineHeight={'1.5'}>
                                                    Płatność i dostawa w jednym przycisku
                                                </Text>
                                            </Box>
                                        </ListItem>{' '}
                                        <ListItem display={'flex'} alignItems={'center'}>
                                            <ListIcon
                                                as={CheckIcon}
                                                mr={'30px'}
                                                color={'#171717'}
                                            />
                                            <Box>
                                                <Text fontSize={'16px'} lineHeight={'1.5'}>
                                                    Powiadomienia o niedokończonych zakupach
                                                </Text>
                                            </Box>
                                        </ListItem>{' '}
                                        <ListItem display={'flex'} alignItems={'center'}>
                                            <ListIcon
                                                as={CheckIcon}
                                                mr={'30px'}
                                                color={'#171717'}
                                            />
                                            <Box>
                                                <Text fontSize={'16px'} lineHeight={'1.5'}>
                                                    Zapamiętane formy dostawy (Paczkomat® InPost,
                                                    InPost Kurier, PaczkoPunkt)
                                                </Text>
                                            </Box>
                                        </ListItem>
                                    </List>
                                </Box>
                            }
                            leftSection={
                                <Box py={{ base: '35px', md: 0 }}>
                                    <Heading
                                        as={'h2'}
                                        fontWeight={'600'}
                                        fontSize={{ base: '30px', lg: '34px' }}
                                        lineHeight={{ base: '37px', lg: '48px' }}
                                        marginBottom={'15px'}
                                        color={'white'}
                                    >
                                        InPost Pay
                                    </Heading>
                                    <Text
                                        fontSize={{ base: '16px', lg: '18px' }}
                                        color={'white'}
                                        mb="15px"
                                    >
                                        Skorzystaj z wyjątkowego rozwiązania technologicznego,
                                        łączącego zakupy, płatność i dostawę w jednym przycisku.
                                    </Text>
                                    <Text
                                        fontSize={{ base: '16px', lg: '18px' }}
                                        color={'white'}
                                        mb="30px"
                                    >
                                        Dzięki InPost Pay twoi klienci mogą wygodnie finalizować
                                        zakupy - bez konieczności wypełniania formularzy i podawania
                                        swoich danych. Aplikacja InPost Mobile pamięta dane
                                        kupującego, ulubioną formę dostawy i płatności.
                                    </Text>
                                    <Heading
                                        as={'h3'}
                                        fontWeight={'600'}
                                        fontSize={{ base: '24px', lg: '26px' }}
                                        lineHeight={{ base: '28px', lg: '34px' }}
                                        marginBottom={'15px'}
                                        color={'white'}
                                    >
                                        Zyskaj więcej dzięki InPost Pay
                                    </Heading>
                                    <List
                                        spacing={'15px'}
                                        fontSize={'18px'}
                                        lineHeight={'27px'}
                                        marginBottom={'50px'}
                                    >
                                        <ListItem
                                            color={'#fff'}
                                            display={'flex'}
                                            alignItems={'center'}
                                        >
                                            <ListIcon
                                                color={'#1AAC7A'}
                                                as={CheckIcon}
                                                mr={'30px'}
                                            />
                                            <Box>
                                                <Text fontSize={'16px'} lineHeight={'1.5'}>
                                                    Wzrost konwersji
                                                </Text>
                                            </Box>
                                        </ListItem>
                                        <ListItem
                                            color={'#fff'}
                                            display={'flex'}
                                            alignItems={'center'}
                                        >
                                            <ListIcon
                                                color={'#1AAC7A'}
                                                as={CheckIcon}
                                                mr={'30px'}
                                            />
                                            <Box>
                                                <Text fontSize={'16px'} lineHeight={'1.5'}>
                                                    Mniej porzuconych koszyków
                                                </Text>
                                            </Box>
                                        </ListItem>
                                        <ListItem
                                            color={'#fff'}
                                            display={'flex'}
                                            alignItems={'center'}
                                        >
                                            <ListIcon
                                                color={'#1AAC7A'}
                                                as={CheckIcon}
                                                mr={'30px'}
                                            />
                                            <Box>
                                                <Text fontSize={'16px'} lineHeight={'1.5'}>
                                                    Większą częstotliwość zamówień
                                                </Text>
                                            </Box>
                                        </ListItem>
                                        <ListItem
                                            color={'#fff'}
                                            display={'flex'}
                                            alignItems={'center'}
                                        >
                                            <ListIcon
                                                color={'#1AAC7A'}
                                                as={CheckIcon}
                                                mr={'30px'}
                                            />
                                            <Box>
                                                <Text fontSize={'16px'} lineHeight={'1.5'}>
                                                    Więcej nowych kupujących
                                                </Text>
                                            </Box>
                                        </ListItem>
                                        <ListItem
                                            color={'#fff'}
                                            display={'flex'}
                                            alignItems={'center'}
                                        >
                                            <ListIcon
                                                color={'#1AAC7A'}
                                                as={CheckIcon}
                                                mr={'30px'}
                                            />
                                            <Box>
                                                <Text fontSize={'16px'} lineHeight={'1.5'}>
                                                    Innowacyjność i bezpieczeństwo
                                                </Text>
                                            </Box>
                                        </ListItem>
                                    </List>
                                    <Box
                                        display={'flex'}
                                        flexDirection={{ base: 'column', md: 'row' }}
                                        alignItems={'center'}
                                        gap={'30px'}
                                    >
                                        <StyledButton
                                            href={
                                                'https://pomoc.idosell.com/platnosci/inpost-pay/inpostpay'
                                            }
                                            style={'outline-reverted'}
                                            target="_self"
                                        >
                                            Włącz InPost pay
                                        </StyledButton>
                                        <Link
                                            href={
                                                'https://www.idosell.com/pl/blog/inpost-pay-dolacza-do-wachlarza-rozwiazan-checkoutowych-idosell-1235328074'
                                            }
                                            target="_self"
                                            color={'#fff'}
                                            fontSize={'16px'}
                                            fontWeight={500}
                                            textDecoration={'underline'}
                                            _hover={{ textDecoration: 'none' }}
                                        >
                                            Dowiedz się więcej
                                        </Link>
                                    </Box>
                                </Box>
                            }
                        />
                    </Box>
                    <Box
                        py={{
                            base: 16,
                            md: 20,
                            xl: 24,
                        }}
                        display={'flex'}
                        flexDirection={'column'}
                        gap={'35px'}
                        position={'relative'}
                    >
                        <ContactSection />
                    </Box>
                </div>
            </Box>
        </ThemeProvider>
    );
}
